// src/services/openingHoursOverrides.js
import { apiRequest } from "@services/apiClient";

export const fetchOverrides = async (fromDate, toDate) => {
  return apiRequest({
    method: "GET",
    endpoint: `/clinic/opening-hours-overrides?from=${fromDate}&to=${toDate}`,
  });
};

export const createOverrides = async (payload) => {
  // payload: { dates: ["YYYY-MM-DD", ...], is_closed: bool, open_time?: "HH:MM", close_time?: "HH:MM" }
  return apiRequest({
    method: "POST",
    endpoint: "/clinic/opening-hours-overrides",
    body: payload,
  });
};

export const deleteOverrides = async (dates) => {
  // dates: ["YYYY-MM-DD", ...]
  return apiRequest({
    method: "DELETE",
    endpoint: "/clinic/opening-hours-overrides",
    body: { dates },
  });
};
